export default __webpack_public_path__ + "static/media/logo.e45e4b19.png";